import type { User } from '@/entities/user/user/@x/session';
import type { UserSessionBriefDTO, UserSessionDTO } from '../model/types';

import { Page, PaginationParams } from '@/shared/api/pagination';
import type { AxiosRequestConfig } from 'axios';
import { authInstance } from '@/shared/api/api-instances/auth/api-instance';

export class UserSessionsApi {
  static getSessionsList(
    params: PaginationParams,
    options?: AxiosRequestConfig,
  ) {
    return authInstance.get<Page<UserSessionDTO>>(`/users/sessions`, {
      ...options,
      params,
    });
  }

  static getSessionById(session_id: string, options?: AxiosRequestConfig) {
    return authInstance.get<UserSessionBriefDTO>(
      `/user/session/${session_id}`,
      options,
    );
  }

  static terminateSessionById(
    session_id: string,
    options?: AxiosRequestConfig,
  ) {
    return authInstance.delete(`/user/session/${session_id}`, options);
  }

  static getProfile(options?: AxiosRequestConfig) {
    return authInstance.get<User>(`/profile`, options);
  }
}